import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Tooltip from "@material-ui/core/Tooltip";
import {Typography} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import React, {useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import {validation} from "../../helpers/ValidationHelper";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        margin: 'auto',
        height: `calc(100% - ${theme.spacing(4)}px)`,
    },
    collectionPeriod: {
        width: 150,
    }
}));

const collectionPeriods = [
    {title: "100 Ms", value: 100},
    {title: "200 Ms", value: 200},
    {title: "300 Ms", value: 300},
    {title: "400 Ms", value: 400},
    {title: "500 Ms", value: 500},
    {title: "1 Sec", value: 1000},
    {title: "1.5 Sec", value: 1500},
    {title: "2 Sec", value: 2000},
    {title: "2.5 Sec", value: 2500},
    {title: "3 Sec", value: 3000},
    {title: "3.5 Sec", value: 3500},
    {title: "4 Sec", value: 4000},
    {title: "4.5 Sec", value: 4500},
    {title: "5 Sec", value: 5000},
    {title: "10 Sec", value: 10000},
    {title: "15 Sec", value: 15000},
    {title: "20 Sec", value: 20000},
    {title: "25 Sec", value: 25000},
    {title: "30 Sec", value: 30000}
];

function validateTitleValue(value) {
    return !!value;
}

export default function PipeCardEdit({
                                         pipe,
                                         children,
                                         onTitleChanged,
                                         onStatusChanged,
                                         onPeriodChanged,
                                         onApplyClick,
                                         onDeviceConfigurationClick
                                     }) {
    const classes = useStyles();

    const [applying, setApplying] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});

    const hasErrors = !!Object.keys(validationErrors).length;

    const status = pipe.status === "ENABLED";

    const additionalContent = children ? (<Grid item xs={12}>{children}</Grid>) : null;

    function handleTitleChanged(event) {
        setValidationErrors(validation(
            event.target.value,
            "title",
            validationErrors,
            validateTitleValue
        ));

        onTitleChanged(pipe.id, event.target.value);
    }

    function handleStatusChanged(event) {
        onStatusChanged(pipe.id, event.target.checked ? "ENABLED" : "DISABLED");
    }

    function handleStepSizeChanged(event) {
        onPeriodChanged(pipe.id, event.target.value);
    }

    function handleApplyClick() {
        if (hasErrors) return;

        setApplying(true);

        onApplyClick(pipe.id).finally(() => setApplying(false));
    }

    return (
        <Paper className={classes.paper}>
            <Grid container spacing={2} direction={"row"} justify={"space-between"} alignItems={"center"}>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                id={`pipe-title-${pipe.id}`}
                                label="Title"
                                value={pipe.title}
                                error={validationErrors["title"]}
                                inputProps={{
                                    style: {textAlign: "center"}
                                }}
                                onChange={handleTitleChanged}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl>
                                <FormGroup row>
                                    <FormControlLabel
                                        value="pipe-status"
                                        control={
                                            <Switch disableRipple checked={status} onChange={handleStatusChanged}/>
                                        }
                                        label={
                                            <Tooltip title="Operation and data acquisition">
                                                <Typography style={{fontSize: "0.9rem"}}>
                                                    Enabled
                                                </Typography>
                                            </Tooltip>
                                        }
                                    />
                                </FormGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl className={classes.collectionPeriod}>
                                <InputLabel id="pipe-collection-period-label">
                                    Collection Period
                                </InputLabel>
                                <Select id="pipe-collection-period"
                                        value={pipe.period}
                                        onChange={handleStepSizeChanged}
                                >
                                    {
                                        collectionPeriods.map((item, index) => (
                                            <MenuItem key={`pipe-collection-period-${pipe.id}-${index}`}
                                                      value={item.value}
                                            >
                                                {item.title}
                                            </MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                        {additionalContent}
                    </Grid>
                </Grid>
                <Grid container spacing={2} justify={"center"} alignItems={"center"}>
                    <Grid item>
                        <Button size="small"
                                variant="contained"
                                color="primary"
                                disabled={applying || hasErrors}
                                onClick={handleApplyClick}
                        >
                            Apply
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button size="small"
                                variant="contained"
                                color="primary"
                                disabled={applying || hasErrors}
                                onClick={onDeviceConfigurationClick}
                        >
                            Device Configuration
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    );
}